import { Link } from '@packages/shared';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { LinkPromotion } from '../types';

export const PromotionAsLink = ({
  linkReady,
  title,
}: Pick<LinkPromotion, 'linkReady' | 'title'>): JSX.Element => (
  <Link href={linkReady} data-testid={PromotionBannerTestIds.asLink} noLinkStyle>
    {title}
  </Link>
);
